export const hasDefinedValues = <T extends object>(
	obj: T,
	keys?: Array<keyof T>
): boolean => {
	const values = keys ? keys.map((key) => obj[key]) : Object.values(obj);

	return values.some((value) => !!value);
};
